import React, { useEffect, useState } from "react";
import TNButton from "../../../../../reusable-components/TNButton";
import {
  ButtonSize,
  ButtonShape,
  ButtonType,
} from "../../../../../enums/ButtonAttributesEnums";
import {
  CONSTANTS_DATA,
  drawerHeaderStyles,
  tableData,
  truckColumns,
  getEditTruckDefaultValues,
  editTruckDetailValues,
  editTrucksValidationSchema,
  getEditTruckRowData,
} from "./constants";
import styles from "./TruckDetails.module.scss";
import { Drawer, Table, Button } from "antd";
import AddTruckOrdersForm from "./AddTruckOrdersForm";
import { PlacementPositions } from "../../../../../enums/PlacementPositionsEnums";
import CreateJobServices from "../../../../../services/createJob.services";
import ConditionalRender from "../../../../../reusable-components/ConditionalRender";
import BaseTable from "../../../../../Common/BaseTable";
import Form from "../../../../Form";
import { TruckDataListing } from "../../../../../models/TruckDetailListing/truckDetailListing.model";
import { useTruckDetailContext } from "../../../../../context/TruckDetailsContext";
import { AddTruckType } from "../../../../../enums/AddTruckType";
import {
  BidToolFromKeys,
  truckDetaildFormKeys,
} from "./AddTruckOrdersForm/constants";
import { useFormContext } from "react-hook-form";
import {
  getDefaultValues,
  truckDetailsAddFromValidation,
} from "../../constants";
import EditTruckForm from "./EditTruckForm";
import BidToolReferenceForm from "../BidToolReferenceForm";

const TruckDetails = ({
  leadId,
  isEditable,
  dropOffLatLng,
  dropOff,
}: {
  leadId?: string;
  isEditable?: boolean;
}) => {
  const { FetchDropdownOptions, FetchSettingsBidConfig } = CreateJobServices();
  const { data: bidConfigSettingsData } = FetchSettingsBidConfig(undefined);
  const {
    truckDetails,
    removeTruckDetail,
    getTruckDetail,
    updateTruckDetails,
  } = useTruckDetailContext();
  const { NO_DATA, ADD_TRUCK_BTN_TXT, WIDTH, HEIGHT, ADD_TRUCK_DETAILS_TXT } =
    CONSTANTS_DATA;
  const { setValue, clearErrors } = useFormContext();
  const [editData, setEditData] = useState(undefined);
  const [isOpen, setIsOpen] = useState(false);
  const [bidToolReferenceOpen, setBidToolReferenceOpen] = useState<boolean>(false);
  const [selectedOrderData, setSelectedOrderData] = useState<object>({});
  const handleDeleteRow = (row?: any) => {
    removeTruckDetail(row);
  };
  const defaultTruckValues = getDefaultValues(
    false,
    undefined,
    bidConfigSettingsData,
    editData,
    undefined,
    dropOff,
    dropOffLatLng
  );
  const handleOpenDrawer = () => setIsOpen(true);
  const handleCloseDrawer = () => setIsOpen(false);
  const handleAddModalClose = () => {
    setValue("truckTypeFilterOption", undefined);
    setValue("pickupLocation", "");
    setValue("deliveryLocation", String(dropOff));
    setValue(
      "deliveryLocationCoordinates",
      `${dropOffLatLng?.lat}, ${dropOffLatLng?.lng}`
    );
    setValue("materialTruckName", undefined);
    setValue("quantity", undefined);
    setValue("truckingPrice", undefined);
    setValue("truckCost", undefined);
    BidToolFromKeys.map((item) => setValue(item, undefined));
    BidToolFromKeys.map((item) => clearErrors(item));
    truckDetaildFormKeys.map((item) => clearErrors(item));
    handleCloseDrawer();
  };

  const handleBidToolReferenceOpen = (record) => {
    setSelectedOrderData({
      ...defaultTruckValues,
      truckPrice: record?.truckingPrice,
      truckingCost: record?.truckingCost,
      actualBid: record?.truckingPrice,
    })
    setBidToolReferenceOpen(true);
  }

  const handleBidToolReferenceClose = () => {
    setSelectedOrderData({})
    setBidToolReferenceOpen(false)
  };
  const { data: truckOptionsData } = FetchDropdownOptions();
  const trucksTypeObject = truckOptionsData?.find(
    (item) => item.typeofDropDown === "trucksType"
  );

  const [defaultTruckEditValues, setDefaultTruckEditvalues] = useState({});
  const [selectedEditRow, setSelectedEditRow] = useState({});
  const [editedTruckValues, setEditedTruckValues] = useState({});
  const [currentSelectedRow, setSelectedRow] = useState({});
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);

  const handleOpenEditDrawer = () => {
    setIsEditDrawerOpen(true);
  };

  const handleEditRow = (row?: any) => {
    setDefaultTruckEditvalues(getEditTruckDefaultValues(row));
    setSelectedEditRow(getEditTruckRowData(row));
    handleOpenEditDrawer();
  };
  const columns = truckColumns({
    isEditable: true,
    handleDeleteRow: handleDeleteRow,
    handleEditRow: handleEditRow,
    handleOpenBidTool: handleBidToolReferenceOpen,
  });

  const [keyCount, setKeyCount] = useState(1);
  useEffect(() => {
    setKeyCount((prev) => prev + 1);
  }, [isOpen]);
  return (
    <>
      <BidToolReferenceForm
        selectedOrderData={selectedOrderData}
        isOpen={bidToolReferenceOpen}
        handleClose={handleBidToolReferenceClose}
      />
      <Drawer
        key={String(keyCount)}
        visible={isOpen}
        className={styles.AddMaterialForm}
        onClose={handleAddModalClose}
        placement={PlacementPositions.RIGHT}
        width={WIDTH}
        height={HEIGHT}
        title={
          <div className={styles.DrawerHeaderContainer}>
            {ADD_TRUCK_DETAILS_TXT}
          </div>
        }
        headerStyle={drawerHeaderStyles}
        size={ButtonSize.LARGE}
      >
        <Form
          defaultValues={defaultTruckValues}
          validationSchema={truckDetailsAddFromValidation}
        >
          {() => {
            return (
              <AddTruckOrdersForm
                leadId={leadId}
                flowType={AddTruckType.TRUCK_ADD_FLOW}
                onClose={handleCloseDrawer}
                dropdownData={trucksTypeObject}
                presetDropLocation={dropOff}
                presetDropCoordinates={dropOffLatLng}
                truckFormType={AddTruckType.TRUCK_ADD_FLOW}
              />
            );
          }}
        </Form>
      </Drawer>
      <Form
        defaultValues={defaultTruckEditValues}
        validationSchema={editTrucksValidationSchema}
        key={JSON.stringify(defaultTruckEditValues)}
      >
        {({ control: { handleSubmit, _reset } }) => {
          const handleCloseEditDrawer = () => {
            setEditedTruckValues({});
            setIsEditDrawerOpen(false);
            _reset();
          };
          const handleUpdate = () => {
            if (
              currentSelectedRow !== undefined &&
              currentSelectedRow !== null &&
              editedTruckValues
            ) {
              updateTruckDetails(currentSelectedRow, editedTruckValues);
            }
            setEditedTruckValues(null);
            setSelectedRow(null);
            setSelectedEditRow(null);
            handleCloseEditDrawer();
          };
          return (
            <Drawer
              visible={isEditDrawerOpen}
              maskClosable={false}
              destroyOnClose
              className={styles.EditMaterialForm}
              closable={true}
              mask={true}
              getContainer={false}
              onClose={handleCloseEditDrawer}
              placement={PlacementPositions.RIGHT}
              width="70%"
              height="100vh"
              title={
                <div className={styles.DrawerHeaderContainer}>
                  <p>{editTruckDetailValues.header}</p>
                </div>
              }
              headerStyle={drawerHeaderStyles}
              size="large"
              footer={
                <div className={styles.ButtonContainer}>
                  <div
                    className={styles.CancelButton}
                    onClick={handleCloseEditDrawer}
                  >
                    {editTruckDetailValues.cancelButtonLabel}
                  </div>
                  <Button
                    type={ButtonType.PRIMARY}
                    shape={ButtonShape.DEFAULT}
                    size={ButtonSize.LARGE}
                    onClick={handleSubmit(handleUpdate)}
                  >
                    {editTruckDetailValues.saveButtonLabel}
                  </Button>
                </div>
              }
            >
              <EditTruckForm
                defaultValues={selectedEditRow}
                setEditedValues={setEditedTruckValues}
                setSelectedRow={setSelectedRow}
              />
            </Drawer>
          );
        }}
      </Form>
      <div className={styles.ButtonsContainer}>
        <TNButton
          size={ButtonSize.LARGE}
          text={ADD_TRUCK_BTN_TXT}
          shape={ButtonShape.DEFAULT}
          onClick={handleOpenDrawer}
        />
      </div>
      <ConditionalRender
        visible={truckDetails?.length > 0}
        fallback={
          <div className={styles.TruckDetailsContainer}>
            <h1>{NO_DATA}</h1>
            <TNButton
              size={ButtonSize.LARGE}
              shape={ButtonShape.DEFAULT}
              text={ADD_TRUCK_BTN_TXT}
              onClick={handleOpenDrawer}
            />
          </div>
        }
      >
        <div className={styles.tableWrapper}>
          <Table dataSource={truckDetails} columns={columns} />
        </div>
      </ConditionalRender>
    </>
  );
};

export default TruckDetails;
